import { FINALIZE_EVALUATION_PLANNING } from '../../../constants/api'
import errorHandler from '../errorHandler'

export default (termNumber: string, token: string) =>
  fetch(FINALIZE_EVALUATION_PLANNING(termNumber), {
    method: 'POST',
    headers: {
      Authorization: 'Bearer ' + token,
    },
  }).then(errorHandler)
